import { OrganizationPaymentType } from 'data/__generated__';

// La facture est toujours émise par Odoo (migration Stripe→Odoo) ; ce champ ne décrit que QUI encaisse.
export const ORGANIZATION_PAYMENT_TYPE_LABELS: Record<OrganizationPaymentType, string> = {
    [OrganizationPaymentType.Odoo]: 'Odoo (virement / SEPA)',
    [OrganizationPaymentType.CreditCard]: 'Carte bancaire (Stripe)',
    [OrganizationPaymentType.SepaDirectDebit]: 'SEPA (Stripe)',
    [OrganizationPaymentType.NoPayment]: 'Sans encaissement',
};
